// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import { deepmerge } from "@mui/utils";

import base from "./base";
import MuiContainer from "./components/MuiContainer";
import MuiPaper from "./components/MuiPaper";
import MuiTextField from "./components/MuiTextField";

const segurosUnimed = deepmerge(base, {
  components: {
    MuiContainer,
    MuiTextField,
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&$focused:not($error)": {
            color: "#1F64BC",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&$focused $notchedOutline": {
            borderColor: "#6191EF",
          },
        },
      },
    },
    MuiPaper: {
      ...MuiPaper,
      styleOverrides: {
        root: {
          "&.ServiceCardCovid": {
            backgroundColor: "#FFFFFF",
            border: `1px solid #DCDDE0`,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&.StyledAppBarIcon": {
            color: "#002D72",
          },
          "&.NavigateNextIcon": {
            color: "#6AD1E3",
          },
          "&.PersonalDrawerIcon": {
            color: "#FFFFFF",
          },
          "&.AnswerAgainIcon": {
            color: "#FFFFFF",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&.AppointmentsButton": {
            color: "#009DDB",
          },
          "&.HomeButton": {
            color: "#FFFFFF",
          },
        },
      },
    },
    MuiEditIcon: {
      styleOverrides: {
        root: {
          "&.AnswerAgainIcon": {
            color: "#FFFFFF",
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          "&.AnswerAgainButton": {
            color: "#FFFFFF",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "&.BreadcrumbsStyledTypography": {
            color: "#005EB8",
          },
          "&.HealthcareServiceName": {
            color: "#FFFFFF",
          },
          "&.Header": {
            color: "#FFFFFF",
          },
          "&.FastContact": {
            color: "#FFFFFF",
          },
          "&.ServiceCardWhatsapp": {
            color: "#FFFFFF",
          },
        },
      },
    },
  },
  typography: {
    h6: {
      color: "#005EB8",
    },
    h3: {
      color: "#FFFFFF",
    },
  },
  palette: {
    primary: {
      light: "#002D72",
      main: "#002D72",
      dark: "#009DDB",
      background: "rgba(97, 145, 239, 0.5)",
      contrastText: "rgba(19, 23, 32, 0.87)",
    },
    secondary: {
      light: "#1F64BC",
      main: "#002D72",
      dark: "#002D72",
      background: "rgba(97, 145, 239, 0.5)",
      contrastText: "rgba(255, 255, 255)",
    },
    error: {
      light: "#FA898F",
      main: "#F5474F",
      dark: "#CC1821",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    warning: {
      light: "#FFDD4B",
      main: "#FFAB00",
      dark: "#C67C00",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    info: {
      light: "#6ECBFF",
      main: "#269AE7",
      dark: "#006CB4",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    success: {
      light: "#87C98A",
      main: "#48A74C",
      dark: "#39873C",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    background: {
      default: "#FFFFFF",
    },
    text: {
      primary: "#505767",
      secondary: "rgba(19, 23, 32, 0.54)",
      disabled: "rgba(19, 23, 32, 0.54)",
      hint: "rgba(19, 23, 32, 0.38)",
    },
    grey: {
      50: "#F5F6FA",
      100: "#F1F2F5",
      200: "#E6E7EB",
      300: "#DCDDE0",
      400: "#BFC1C7",
      500: "#98999E",
      600: "#6C6E75",
      700: "#363840",
      800: "#202229",
      900: "#131720",
      A100: "#D2D3D6",
      A200: "#A4A6AB",
      A400: "#515661",
      A700: "#1D2230",
    },
    divider: "#DCDDE0",
    action: {
      active: "#DCDDE0",
      disabledBackground: "rgba(227, 227, 228, 1)",
    },
  },
});

export default segurosUnimed;
